const initSlider = (container) => {
  const slider = container.querySelector('.promotion');
  const arrowLeft = container.querySelector('.arrow');
  const arrowRight = container.querySelector('.arrow-right');
  let scrollAmount = 0;

  const bindEvents = () => {
    arrowLeft?.addEventListener('click', () => horizontalScroll('back'));
    arrowRight?.addEventListener('click', horizontalScroll);
    window.addEventListener('resize', renderArrows);
    slider.addEventListener('scroll', renderArrows);
  };

  const horizontalScroll = (direction) => {
    scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction === 'back') {
        slider.scrollLeft -= 70;
      } else {
        slider.scrollLeft += 70;
      }

      setArrowsFromScrollStates();
      scrollAmount += 70;
      if (scrollAmount >= 500) {
        window.clearInterval(slideTimer);
      }
    }, 27);
  };

  const arrowContainer = container.querySelector('.arrow-container');

  const renderArrows = () => {
    if (slider.scrollWidth > slider.clientWidth) {
      arrowContainer?.classList.add('d-lg-flex');
      slider.classList.add('has-overflow');
      setArrowsFromScrollStates();
    } else {
      arrowContainer?.classList.add('d-none');
      arrowContainer?.classList.remove('d-lg-flex');
      slider.classList.remove('has-overflow');
    }
  };

  const setArrowsFromScrollStates = () => {
    if (slider.scrollWidth - 1 < slider.clientWidth + slider.scrollLeft) {
      arrowRight?.classList.add('disabled');
    } else {
      arrowRight?.classList.remove('disabled');
    }
    if (slider.scrollLeft === 0) {
      arrowLeft?.classList.add('disabled');
    } else {
      arrowLeft?.classList.remove('disabled');
    }
  };

  bindEvents();
  renderArrows();
};

document.addEventListener('DOMContentLoaded', function () {
  Array.from(document.querySelectorAll('.promotion-container')).forEach((container) => {
    initSlider(container);
  });
});
